import { useState, useEffect } from "react";
import { Users } from "lucide-react";

const LiveVisitorCounter = () => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    // Simulate realistic visitor count (3-12 visitors)
    const baseCount = Math.floor(Math.random() * 10) + 3;
    setCount(baseCount);

    // Periodically update to simulate activity
    const interval = setInterval(() => {
      setCount(prev => {
        const change = Math.random() > 0.5 ? 1 : -1;
        const newCount = prev + change;
        return Math.max(2, Math.min(15, newCount));
      });
    }, 8000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="fixed bottom-4 left-4 z-40 animate-fade-in" style={{ animationDelay: '3s' }}>
      <div className="flex items-center gap-2 px-3 py-2 rounded-full bg-card/95 backdrop-blur border border-border shadow-lg">
        <span className="relative flex h-2 w-2">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-success opacity-75"></span>
          <span className="relative inline-flex rounded-full h-2 w-2 bg-success"></span>
        </span>
        <Users className="h-4 w-4 text-muted-foreground" />
        <span className="text-sm font-medium text-foreground">
          <span className="text-success font-bold">{count}</span> people viewing
        </span>
      </div>
    </div>
  );
};

export default LiveVisitorCounter;
